import { ContactEditComponent } from './contact-edit/contact-edit.component';
import { ContactsComponent } from './contacts.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { SharedModule } from 'app/shared/shared.module';
import { MomentModule } from 'ngx-moment';

@NgModule({
  declarations: [
    ContactsComponent,
    ContactEditComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    ReactiveFormsModule,
    MomentModule
  ]
})
export class ContactsModule { }
